import { createSlice } from '@reduxjs/toolkit';
import { AES, enc } from 'crypto-js';

// Import local storage keys 
import { USER_INFO_KEY, } from 'constants';

// Import object handler
import { updateNestedProperty, } from 'utils/objects';

const initialState = {
  userInfo: getDecryptedUserInfo(),
};

function getDecryptedUserInfo() {
  const encryptedUserInfo = localStorage.getItem(USER_INFO_KEY);
  if (encryptedUserInfo) {
    try {
      return JSON.parse( AES.decrypt(encryptedUserInfo, import.meta.env.VITE_ENCRYPTION_KEY).toString(enc.Utf8) );
    } catch (error) {
      console.error('Error decrypting user info:', error);
      return null;
    }
  }
  return null;
}

function encryptUserInfo(userInfo) {
  return AES.encrypt(userInfo, import.meta.env.VITE_ENCRYPTION_KEY).toString();
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {

      const data = action.payload;
            
      state.userInfo = data;
      // state.userToken = token;

      const encryptedUserInfo = encryptUserInfo(JSON.stringify(data));
      localStorage.setItem(USER_INFO_KEY, encryptedUserInfo);
    },
    updateUserInfo: (state, action) => {

      const { field, data } = action.payload;

      let updatedUserInfo = updateNestedProperty(state.userInfo, field, data);

      if ( field.toLowerCase() === 'replace' ) {

        updatedUserInfo = data;

      }
      
      state.userInfo = updatedUserInfo;

      const encryptedUserInfo = encryptUserInfo(JSON.stringify(updatedUserInfo));
      localStorage.setItem(USER_INFO_KEY, encryptedUserInfo);

    },
    logout: (state, action) => {
      state.userInfo = null;

      window.location.replace("/login");

      localStorage.removeItem(USER_INFO_KEY);
    },
  },
});

export const { setCredentials, updateUserInfo, logout } = authSlice.actions;

export default authSlice.reducer;